import type { SettlementItem } from "../../types";

interface SettlementCardProps {
  invoice: SettlementItem;
  formatDate: (value?: string) => string;
  formatCurrency: (value?: number | null) => string;
  formatOverdue: (value?: number | string) => string;
}

const SettlementCard = ({
  invoice,
  formatDate,
  formatCurrency,
  formatOverdue,
}: SettlementCardProps) => {
  const overdue = Number(invoice.overdueDays || 0);
  const issued = formatDate(invoice.issuedAt);
  const due = formatDate(invoice.dueDate);

  return (
    <article className={`settlement-card${overdue > 0 ? " overdue" : ""}`}>
      <header>
        <h3>{invoice.invoiceNumber || "-"}</h3>
        <span>{issued || "-"}</span>
      </header>
      <p>Kwota brutto: {formatCurrency(invoice.grossAmount)}</p>
      <p>Pozostało: {formatCurrency(invoice.amountDue)}</p>
      <p>Warunki: {invoice.paymentTermsCode || "-"}</p>
      <p>
        Termin płatności:{" "}
        <strong className={overdue > 0 ? "overdue-text" : ""}>
          {due || "-"}
        </strong>
      </p>
      <p>
        Dni po terminie:{" "}
        <strong className={overdue > 0 ? "overdue-text" : ""}>
          {formatOverdue(invoice.overdueDays)}
        </strong>
      </p>
    </article>
  );
};

export default SettlementCard;
